import { Link } from '@tanstack/react-router'
import { Bot } from 'lucide-react'
import { copy } from '../../copy/investor-copy'

/** The footer line under Search: the same assistant, in the chat apps the investor already uses. */
export function ConnectAiLink({ investorId }: { investorId: string }) {
  return (
    <div className="flex justify-end border-t border-border pt-4">
      <p className="flex flex-wrap items-center gap-1.5 text-xs text-muted-foreground">
        <Bot className="size-3.5" />
        <span>{copy('search.connect')}</span>
        <Link
          to="/app/investor/$id/connect-ai"
          params={{ id: investorId }}
          className="font-medium text-foreground hover:underline"
        >
          {copy('ai.connect')}
        </Link>
      </p>
    </div>
  )
}
